import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import {
  Box,
  List,
  ListItemText,
  ListItemButton,
  ListItemIcon,
  FormControl,
  Select,
  Typography,
  Button,
  CircularProgress,
} from "@mui/material";
import { useMediaQuery } from "@mui/material";
import AppsIcon from "@mui/icons-material/Apps";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { useTheme } from "@mui/material/styles";
import "./MaatwerkResultaten.css";
import { useTranslation } from "react-i18next";
import Error from "../../components/Error";
import GridViewRoundedIcon from "@mui/icons-material/GridViewRounded";
import MaatwerkSummary from "./MaatwerkSummary";
import AdvisorWidget from "./AdvisorWidget";
import ResultsHeader from "../../pages/Results/ResultsHeader";

const REACT_APP_BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const REACT_APP_STATIC_URL = process.env.REACT_APP_STATIC_URL;

const Alert = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 0C8.85652 0 10.637 0.737498 11.9497 2.05025C13.2625 3.36301 14 5.14348 14 7C14 8.85652 13.2625 10.637 11.9497 11.9497C10.637 13.2625 8.85652 14 7 14C5.14348 14 3.36301 13.2625 2.05025 11.9497C0.737498 10.637 0 8.85652 0 7C0 5.14348 0.737498 3.36301 2.05025 2.05025C3.36301 0.737498 5.14348 0 7 0ZM7 2.69231C6.5524 2.69231 6.19231 3.0524 6.19231 3.5V7.26923C6.19231 7.71683 6.5524 8.07692 7 8.07692C7.4476 8.07692 7.80769 7.71683 7.80769 7.26923V3.5C7.80769 3.0524 7.4476 2.69231 7 2.69231ZM8.07692 10.2308C8.07692 9.94515 7.96346 9.67123 7.7615 9.46927C7.55954 9.26731 7.28562 9.15385 7 9.15385C6.71438 9.15385 6.44046 9.26731 6.2385 9.46927C6.03654 9.67123 5.92308 9.94515 5.92308 10.2308C5.92308 10.5164 6.03654 10.7903 6.2385 10.9923C6.44046 11.1942 6.71438 11.3077 7 11.3077C7.28562 11.3077 7.55954 11.1942 7.7615 10.9923C7.96346 10.7903 8.07692 10.5164 8.07692 10.2308Z"
        fill="#E54344"
      />
    </svg>
  );
};

const Warning = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 12C7.5913 12 9.11742 11.3679 10.2426 10.2426C11.3679 9.11742 12 7.5913 12 6C12 4.4087 11.3679 2.88258 10.2426 1.75736C9.11742 0.632141 7.5913 0 6 0C4.4087 0 2.88258 0.632141 1.75736 1.75736C0.632141 2.88258 0 4.4087 0 6C0 7.5913 0.632141 9.11742 1.75736 10.2426C2.88258 11.3679 4.4087 12 6 12ZM5.0625 7.875H5.625V6.375H5.0625C4.75078 6.375 4.5 6.12422 4.5 5.8125C4.5 5.50078 4.75078 5.25 5.0625 5.25H6.1875C6.49922 5.25 6.75 5.50078 6.75 5.8125V7.875H6.9375C7.24922 7.875 7.5 8.12578 7.5 8.4375C7.5 8.74922 7.24922 9 6.9375 9H5.0625C4.75078 9 4.5 8.74922 4.5 8.4375C4.5 8.12578 4.75078 7.875 5.0625 7.875ZM6 3C6.19891 3 6.38968 3.07902 6.53033 3.21967C6.67098 3.36032 6.75 3.55109 6.75 3.75C6.75 3.94891 6.67098 4.13968 6.53033 4.28033C6.38968 4.42098 6.19891 4.5 6 4.5C5.80109 4.5 5.61032 4.42098 5.46967 4.28033C5.32902 4.13968 5.25 3.94891 5.25 3.75C5.25 3.55109 5.32902 3.36032 5.46967 3.21967C5.61032 3.07902 5.80109 3 6 3Z"
        fill="#FF8C00"
      />
    </svg>
  );
};

const NoRisk = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 0C8.85652 0 10.637 0.737498 11.9497 2.05025C13.2625 3.36301 14 5.14348 14 7C14 8.85652 13.2625 10.637 11.9497 11.9497C10.637 13.2625 8.85652 14 7 14C5.14348 14 3.36301 13.2625 2.05025 11.9497C0.737498 10.637 0 8.85652 0 7C0 5.14348 0.737498 3.36301 2.05025 2.05025C3.36301 0.737498 5.14348 0 7 0ZM10.8029 5.41827C11.1192 5.10192 11.1192 4.59039 10.8029 4.2774C10.4865 3.96442 9.975 3.96106 9.66202 4.2774L5.92644 8.01298L4.34471 6.43125C4.02837 6.1149 3.51683 6.1149 3.20385 6.43125C2.89087 6.7476 2.8875 7.25913 3.20385 7.57212L5.35769 9.72596C5.67404 10.0423 6.18558 10.0423 6.49856 9.72596L10.8029 5.41827Z"
        fill="#27CA40"
      />
    </svg>
  );
};

const MaatwerkResultaten = () => {
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.between("mobile", "ipad"));
  const tablet = useMediaQuery(theme.breakpoints.between("ipad", "laptop"));
  const { requestId } = useParams();
  const [checks, setChecks] = useState([]);
  const [request, setRequest] = useState(null);
  const [selectedCheck, setSelectedCheck] = useState(false);
  const [showScrollButton, setShowScrollButton] = useState(false);
  const boxRef = useRef(null);
  const { t, i18n } = useTranslation();
  const [getResultsLoading, setGetResultsLoading] = useState(false);
  const [getResultsError, setGetResultsError] = useState(null);

  function scrollToTop() {
    if (mobile) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else if (boxRef.current) {
      boxRef.current.scrollTo({ top: 0, behavior: "smooth" });
    }
  }


  const getChecks = async () => {
    setGetResultsLoading(true);
    setGetResultsError(null);
    try {
      const response = await fetch(`${REACT_APP_BACKEND_URL}/result/maatwerk/${requestId}`, {
        method: "GET",
      });
      if (!response.ok) {
        throw new Error("Failed to fetch results");
      }
      const data = await response.json();
      setChecks(data?.checks);
      setRequest(data?.request);
    } catch (error) {
      setGetResultsError(error.message);
    } finally {
      setGetResultsLoading(false);
    }
  };

  const handleListItemClick = (event, check) => {
    setSelectedCheck(check);
  };

  const isRental = request?.module?.name?.toLowerCase().includes("huren");

  function renderHtml(result) {
    // Vervang eerst de URL in alle gevallen
    let updatedHtml;

    if (i18n.language === "nl") {
      updatedHtml = result.textHtmlNL;
    } else if (i18n.language === "en") {
      updatedHtml = result.textHtmlEN;
    } else {
      updatedHtml = "";
    }

    // Voeg een margin-bottom toe aan de "cmp-container" als readMoreHtml bestaat
    if (!!result.readMoreHtmlNL && result.readMoreHtmlNL !== "") {
      updatedHtml = updatedHtml.replace(
        "cmp-container",
        "cmp-container has-read-more"
      );

      updatedHtml += ``;
    }
    return updatedHtml;
  }

  useEffect(() => {
    getChecks();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [requestId]);

  useEffect(() => {
    if (!mobile) return;

    const handleScroll = () => {
      const scrolled = window.scrollY > window.innerHeight;
      setShowScrollButton(scrolled);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [mobile]);



  useEffect(() => {
    if (mobile) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else if (boxRef.current) {
      boxRef.current.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [selectedCheck, mobile]);

  return (
    <div className="results-page-container">
      <ResultsHeader
        request={request}
        checks={checks}
        isLoading={getResultsLoading}
        setShowDeleteModal={() => {}}
      />

      {getResultsLoading && (
        <Box
          sx={{
            height: mobile ? "100px" : "200px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CircularProgress />
        </Box>
      )}

      <Box
        sx={{
          display: "flex",
          height: getResultsLoading ? "20px" : "auto",
          gap: "24px",
          width: tablet ? "min(100%, 95vw)" : "auto",
        }}
      >
        {getResultsError && <Error />}
        {checks?.length !== 0 && !getResultsLoading && (
          <React.Fragment>
            <div className="results-menu">
              <List
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "8px",
                  padding: "12px",
                  overflowY: "hidden",
                }}
              >
                <Box sx={{ padding: "18px 12px" }}>
                  <Typography
                    variant="h2"
                    sx={{ fontSize: "20px", fontWeight: 600, color: "#439BD9" }}
                  >
                    {t("alleOnderwerpen")}
                  </Typography>
                </Box>
                <ListItemButton
                  selected={selectedCheck === false}
                  onClick={(event) => handleListItemClick(event, false)}
                  sx={{
                    display: "flex",
                    gap: "16px",
                    padding: "12px 18px",
                    borderRadius: "8px",
                    "&:hover": {
                      backgroundColor: "#F9FCFE",
                    },
                    "& .MuiListItemIcon-root": {
                      minWidth: "18px",
                      "& img": {
                        filter: "none", // default state
                      },
                    },
                    "& .MuiListItemText-root .MuiTypography-root": {
                      fontSize: "14px",
                      fontWeight: 500,
                      color: "#000000",
                    },
                    "&.Mui-selected": {
                      backgroundColor: "#F0F7FC",

                      "& .MuiListItemText-root .MuiTypography-root": {
                        fontWeight: 600,
                        color: "#439BD9",
                      },
                    },
                  }}
                >
                  <ListItemIcon>
                    <AppsIcon
                      sx={{
                        color: selectedCheck === false ? "#439BD9" : "#454545",
                        fontSize: "18px",
                      }}
                    />
                  </ListItemIcon>
                  <ListItemText>{t("samenvatting")}</ListItemText>
                </ListItemButton>

                <div className="checklist-container">
                  {checks.every(
                    (check) => check.textInstanceResults.length !== 0
                  ) !== 0 &&
                    checks
                      .sort(
                        (a, b) =>
                          a.textInstanceResults[0].variableOptionInstance
                            .riskLevel -
                          b.textInstanceResults[0].variableOptionInstance
                            .riskLevel
                      )
                      .map((check, index) => (
                        <ListItemButton
                          key={index}
                          selected={selectedCheck?.id === check.id}
                          onClick={(event) => handleListItemClick(event, check)}
                          sx={{
                            display: "flex",
                            gap: "16px",
                            padding: "16px",
                            borderRadius: "8px",
                            "&:hover": {
                              backgroundColor: "#F9FCFE",
                            },
                            "& .MuiListItemIcon-root": {
                              minWidth: "18px",
                              "& img": {
                                filter: "none", // default state
                              },
                            },
                            "& .MuiListItemText-root .MuiTypography-root": {
                              fontSize: "14px",
                              fontWeight: 500,
                              color: "#000000",
                            },
                            "&.Mui-selected": {
                              backgroundColor: "#F0F7FC",

                              "& .MuiListItemText-root .MuiTypography-root": {
                                fontWeight: 600,
                                color: "#439BD9",
                              },
                            },
                          }}
                        >
                          <ListItemIcon>
                            <img
                              src={`${REACT_APP_STATIC_URL}/icons/${
                                check?.iconUrl || ""
                              }${
                                selectedCheck?.id !== check.id ? "-bl" : ""
                              }${".svg"}`}
                              alt="Checklist"
                              style={{ width: "18px", height: "18px" }}
                            />
                          </ListItemIcon>
                          <ListItemText key={check.id}>
                            {" "}
                            {t(`check.${check?.name || ""}`)}
                          </ListItemText>
                          <Box
                            sx={{
                              width: "14px",
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            {check.textInstanceResults[0].variableOptionInstance
                              .riskLevel === 2 ? (
                              <Alert />
                            ) : check.textInstanceResults[0]
                                .variableOptionInstance.riskLevel === 1 ? (
                              <Warning />
                            ) : (
                              <NoRisk />
                            )}
                          </Box>
                        </ListItemButton>
                      ))}
                </div>
              </List>
              {/* <Divider /> */}
              {/* <div
              className="back-btn"
              onClick={() => {
                window.history.back();
              }}
            >
              <ArrowBackIosIcon sx={{ fontSize: "16px", marginRight: "8px" }} />
              <span>{t("terug")}</span>
            </div> */}
            </div>

            <div className="results-main" ref={boxRef}>
              {mobile && (
                <FormControl
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    gap: "8px",
                    justifyContent: "center",
                    margin: "18px",
                  }}
                >
                  <Button
                    startIcon={<GridViewRoundedIcon />}
                    onClick={() => setSelectedCheck(false)}
                    disabled={selectedCheck === false}
                    sx={{
                      textTransform: "none",
                      fontSize: "16px",
                      fontWeight: 500,
                      color: selectedCheck === false ? "#9CA3AF" : "#439BD9",
                      padding: "6px 24px",
                      borderRadius: "8px",
                      border:
                        selectedCheck === false
                          ? "1px solid #E5E7EB"
                          : "1px solid #DCEDFA",
                      backgroundColor:
                        selectedCheck === false ? "#F3F4F6" : "#F9FCFE",
                      cursor:
                        selectedCheck === false ? "not-allowed" : "pointer",
                      "&:disabled": {
                        color: "#9CA3AF",
                        backgroundColor: "#F3F4F6",
                        border: "1px solid #E5E7EB",
                      },
                    }}
                  >
                    {t("Overzicht")}
                  </Button>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={selectedCheck?.id || "Kiezen"}
                    onChange={(e, check) => {
                      if (e.target.value === "false") {
                        setSelectedCheck(false);
                      } else {
                        const selected = checks.find(
                          (check) => check.id === e.target.value
                        );
                        setSelectedCheck(selected);
                      }
                    }}
                    sx={{
                      display: "flex",
                      backgroundColor: "#F9FCFE",
                      justifyContent: "center",
                      fontSize: "16px",
                      fontWeight: 500,
                      color: "#439BD9",
                      borderRadius: "8px",
                      border: "1px solid #DCEDFA",
                      outline: "none",
                      "& .MuiOutlinedInput-notchedOutline": {
                        border: "none",
                      },
                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        border: "none",
                      },
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        border: "none",
                      },
                      "& .MuiNativeSelect-icon": {
                        fill: "#439BD9!important",
                        color: "#439BD9!important",
                      },
                    }}
                    native={true}
                  >
                    <option value="Kiezen" disabled>
                      {t("Selecteer een check")}
                    </option>

                    {checks.map((check, index) => {
                      return (
                        <option key={index} value={check?.id}>
                          <span style={{ fontSize: "8px" }}>
                            {check?.textInstanceResults[0]
                              .variableOptionInstance?.riskLevel === 0 && "🟢"}
                            {check?.textInstanceResults[0]
                              .variableOptionInstance?.riskLevel === 1 && "🟠"}
                            {check?.textInstanceResults[0]
                              .variableOptionInstance?.riskLevel === 2 && "🔴"}
                          </span>{" "}
                          {t(`check.${check?.name || ""}`)}
                        </option>
                      );
                    })}
                  </Select>
                </FormControl>
              )}
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: mobile ? "center" : "flex-start",
                  flexWrap: "nowrap",
                  gap: "24px",
                  paddingBottom: mobile ? "18px" : "0",
                }}
              >
                {/* Samenvatting */}
                {selectedCheck === false && (
                  <MaatwerkSummary
                    checks={checks}
                    request={request}
                    setShowDeleteModal={() => {}}
                    setShowModalError={() => {}}
                    setSelectedCheck={setSelectedCheck}
                  />
                )}


                {selectedCheck && (
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "24px",
                    }}
                  >

                    <Box
                      sx={{
                        display: "flex",
                        gap: "24px",
                        flexDirection: mobile || tablet ? "column" : "row",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "24px",
                        }}
                      >
                        {selectedCheck &&
                          selectedCheck.textInstanceResults
                            .filter(
                              (result) =>
                                result.textInstance.orientation === "LEFT"
                            )
                            .sort(
                              (a, b) =>
                                a.textInstance.order - b.textInstance.order
                            )
                            .map((result) => (
                              <Box
                                key={result.id}
                                sx={{
                                  display: "flex",
                                  justifyContent: "center",
                                }}
                              >
                                <div
                                  className="result-item"
                                  dangerouslySetInnerHTML={{
                                    __html: renderHtml(result),
                                  }}
                                />
                                
                              </Box>
                            ))}
                      </Box>

                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "24px",
                        }}
                      >
                        {selectedCheck &&
                          selectedCheck.textInstanceResults
                            .filter(
                              (result) =>
                                result.textInstance.orientation === "RIGHT"
                            )
                            .sort(
                              (a, b) =>
                                a.textInstance.order - b.textInstance.order
                            )
                            .map((result) => (
                              <div key={result.id}>
                                <div
                                  className="result-item"
                                  dangerouslySetInnerHTML={{
                                    __html: renderHtml(result),
                                  }}
                                />

                              </div>
                            ))}

                        {!isRental &&
                          selectedCheck.textInstanceResults[0]
                            ?.variableOptionInstance?.riskLevel > 0 && (
                            <AdvisorWidget standalone className="detail" />
                          )}
                      </Box>
                    </Box>
                  </Box>
                )}
              </Box>
            </div>
          </React.Fragment>
        )}

        {/* Scroll to top button - alleen op mobiel en na scrollen */}
        {mobile && !getResultsLoading && (
          <div
            onClick={scrollToTop}
            style={{
              position: "fixed",
              bottom: "24px",
              right: "15%",
              transform: "translateX(50%)",
              width: "36px",
              height: "36px",
              backgroundColor: "#439BD9",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              boxShadow: "0 4px 12px rgba(67, 155, 217, 0.3)",
              zIndex: 1000,
              opacity: showScrollButton ? 1 : 0,
              visibility: showScrollButton ? "visible" : "hidden",
              transition:
                "opacity 0.3s ease-in-out, visibility 0.3s ease-in-out",
            }}
          >
            <KeyboardArrowUpIcon
              sx={{
                color: "#fff",
                fontSize: "18px",
              }}
            />
          </div>
        )}
      </Box>
      
    </div>
  );
};

export default MaatwerkResultaten;
